<template>
  <div v-show="message" data-test="input-error">
    <WebErrorMessage>{{ capitalizeMessage }}</WebErrorMessage>
  </div>
</template>

<script>
import WebErrorMessage from '@/Web/Components/WebErrorMessage.vue'

export default {
  components: { WebErrorMessage },

  props: {
    message: {
      type: String,
      default: '',
    },
  },

  computed: {
    capitalizeMessage() {
      return this.message.charAt(0).toUpperCase() + this.message.slice(1)
    },
  },
}
</script>
